import React from "react";
import { useEffect } from 'react';

export default function AdminProjects() {
	useEffect(() => {
		document.title = `Delta M. Crm. ${window.captions.Project}`;
	}, []);

	return <div />;
}